export const RANDOM_PROFILE_IMAGE_URL = "https://i.pravatar.cc/300";
export const RANDOM_PROFILE_PLACEHOLDER = "https://ramcotubular.com/wp-content/uploads/default-avatar.jpg";